import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactStars from 'react-rating-stars-component';
import Button from '@mui/material/Button';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ClosedCaptionOutlinedIcon from '@mui/icons-material/ClosedCaptionOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import ShareIcon from '@mui/icons-material/Share';

import classes from './ComplementaryInfo.module.css';
const urlNew = window.location.host;

const ComplementaryInfo = props => {
  const { t } = useTranslation(['course']);
  const [linkCopied, setLinkCopied] = useState(false);
  const copyLinkHandler = () => {
    const copyText = document.getElementById('urlCourseCopy');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand('copy');
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 3000);
  };
  return (
    <div className={classes.extraInfoContainer}>
      <aside className={classes.extraInfoReviewsSection}>
        {!props.data.reviewsEnabled ? (
          <>
            <p className={classes.textDescriptionCourse}>
              {t('user_reviews')}
            </p>
            <aside className={classes.starsContainer}>
              <ReactStars
                edit={false}
                count={5}
                isHalf={true}
                size={24}
                activeColor="#e6a817"
                emptyStarColor="#d6d6d6"
                value={props.data.votes / props.data.noReviews}
              />
            </aside>
            {parseInt(props.aditionalData.positiveRatingPercent) >
              50 && (
              <p className={classes.textUsersCourse}>
                {parseInt(props.aditionalData.positiveRatingPercent)}
                % {t('positive_feedback')} (
                {props.aditionalData.totalReviews})
              </p>
            )}
          </>
        ) : (
          <p className={classes.textUsersCourseBlack}>.</p>
        )}
      </aside>
      <aside className={classes.extraInfoSection}>
        {props.usersInCourse >= 20 && (
          <p className={classes.textUsersCourse}>
            <GroupOutlinedIcon className={classes.iconStudents} />
            {t('enrolled_students')}: {props.usersInCourse}
          </p>
        )}
        <p className={classes.textUsersCourse}>
          <ClosedCaptionOutlinedIcon
            className={classes.iconStudents}
          />
          {props.aditionalData.ccData.map(cc => (
            <span key={cc.language}>{cc.description}</span>
          ))}
        </p>
        <Button
          className={classes.shareBtn}
          onClick={copyLinkHandler}
        >
          <ShareIcon className={classes.iconShare} /> {t('share')}
        </Button>
        <input
          className={classes.shareInput}
          type="text"
          value={`https://${urlNew}/${props.data.shortNameEmisor}/c/${props.data.idLista}`}
          id="urlCourseCopy"
        />
        {linkCopied && (
          <p className={classes.shareText}>{t('copied_link')}</p>
        )}
      </aside>
      <aside className={classes.extraInfoSection}>
        <p className={classes.textUsersCourse}>
          <VolumeUpOutlinedIcon className={classes.iconStudents} />
          {t('audio')}: Español
        </p>
      </aside>
    </div>
  );
};

ComplementaryInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  aditionalData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  usersInCourse: PropTypes.number
};

export default ComplementaryInfo;
